import { combineReducers } from 'redux';
import actionTypes from './actionTypes';

import { REDUCER_NAME } from './constants';

import sheetsReducer from './sheets/reducer';
import { REDUCER_NAME as SHEETS_REDUCER_NAME } from './sheets/constants';

import bookReducer from './book/reducer';
import { REDUCER_NAME as BOOK_REDUCER_NAME } from './book/constants';

const initialState = {
  batch: [],
  isFetching: true,
};

const batchesReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default combineReducers({
  [REDUCER_NAME]: batchesReducer,
  [SHEETS_REDUCER_NAME]: sheetsReducer,
  [BOOK_REDUCER_NAME]: bookReducer,
});
